var _require = require('prettier/standalone'),
    join = _require.doc.builders.join;

var VariableDeclaration = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;

    if (!node.typeName) {
      return node.name;
    }

    var doc = path.call(_print, 'typeName');

    if (node.isIndexed) {
      doc = join(' ', [doc, 'indexed']);
    }

    var constantKeyword = node.isDeclaredConst ? 'constant' : '';

    if (node.visibility === 'default') {
      return join(' ', [doc, node.typeName.stateMutability, constantKeyword, node.name].filter(function (element) {
        return element;
      }));
    }

    return join(' ', [doc, node.typeName.stateMutability, node.visibility, constantKeyword, node.storageLocation, node.name].filter(function (element) {
      return element;
    }));
  }
};
module.exports = VariableDeclaration;